import { render } from "./MsThOptionText.vue?vue&type=template&id=59e26dba"
import script from "./MsThOptionText.vue?vue&type=script&lang=js"
export * from "./MsThOptionText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__